import React, { Component } from "react";
import { Layout, Button, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { ThemeProvider } from "styled-components";
import { connect } from 'react-redux';
import propTypes from "prop-types";
import { Div, SmallScreenAuthInfo } from "./style";
import AuthInfo from "../components/utilities/auth-info/info";
import moment from "moment";
import TopMenu from "./TopMenu";
import { changeLayoutMode } from '../redux/themeLayout/actionCreator';
import { HomeOutlined } from '@ant-design/icons';

const { darkTheme } = require("../config/theme/themeVariables");
const { Header, Footer, Sider, Content } = Layout;

const ThemeLayout = (WrappedComponent) => {

    class LayoutComponent extends Component {
        constructor(props) {
            super(props);
            this.state = {
                hide: false,
                collapsed: false, // window.innerWidth <= 1200,
            };
        }

        componentDidMount() {
            window.addEventListener("resize", this.updateDimensions);
        }

        componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimensions);
        }

        updateDimensions = () => {
            // this.setState({ collapsed: window.innerWidth <= 1200 }); 
            this.setState({ collapsed: true }); // Force collapsed state for now
        };

        toggleCollapsed = () => {
            this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
        };

        toggleCollapsedMobile = () => {
            if (window.innerWidth <= 768) {
                this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
            }
        };

        render() {
            const { collapsed, hide } = this.state;
            const { ChangeLayoutMode } = this.props;
            const darkMode = false; //ChangeLayoutMode; 
            const xs = window.innerWidth <= 576; // Adjust breakpoint as needed

            return (
                <Div darkMode={darkMode}>
                    <Layout className="layout">
                        <Header style={{ padding: '0 16px', height: '64px', display: 'flex', alignItems: 'center' }}>
                            <Row align="middle" justify="space-between" style={{ width: '100%', height: '100%', margin: 0 }}>
                                <Col xxl={4} lg={4} md={5} sm={6} xs={6} style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="logo">
                                        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                                            <img 
                                                src={darkMode ? require(`../static/img/login-logo.png`) : require(`../static/img/logo.png`)} 
                                                alt="logo" 
                                                style={{ height: xs ? '22px' : '32px', objectFit: 'contain' }} 
                                            />
                                        </Link>
                                    </div>
                                </Col>
                                <Col xxl={15} lg={15} md={15} sm={10} xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <TopMenu darkMode={darkMode} />
                                </Col>
                                <Col xxl={5} lg={5} md={4} sm={8} xs={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <AuthInfo darkMode={darkMode} />
                                </Col>
                            </Row>
                        </Header>
                        <Layout>
                            <ThemeProvider theme={darkTheme}>
                                <Layout hasSider>
                                    {/* <Sider
                                        width={100}
                                        collapsed={collapsed}
                                        collapsedWidth={0}
                                        theme="light"
                                        style={{
                                            overflowY: 'auto',
                                            // padding: collapsed ? 0 : '15px',
                                            background: '#27589b',
                                            borderRight: '1px solid #f0f0f0',
                                            margin: collapsed ? 0 : '15px 0px 15px 15px',
                                            borderRadius: '10px',
                                        }}
                                    >
                                        <Scrollbars autoHide>
                                            <SidebarMenu />
                                        </Scrollbars>
                                    </Sider> */}

                                    <Content style={{ minHeight: 'calc(100vh - 128px)' }}>
                                        <WrappedComponent {...this.props} />
                                    </Content>
                                </Layout>
                            </ThemeProvider>
                        </Layout>
                        <Footer className="admin-footer" style={{ padding: "20px 30px", textAlign: 'right' }}>
                            <span>
                                2018 - {moment().format("YYYY")} © <Link to="https://www.skilledanswers.com/">SkilledAnswers Info Solutions Pvt Ltd</Link>
                            </span>
                        </Footer>
                    </Layout>
                </Div>
            );
        }
    }

    const mapStateToProps = (state) => {
        return {
            ChangeLayoutMode: state.ChangeLayoutMode.data,
        };
    };

    const mapStateToDispatch = (dispatch) => {
        return {
            changeLayout: (show) => dispatch(changeLayoutMode(show)),
        };
    };

    LayoutComponent.propTypes = {
        ChangeLayoutMode: propTypes.bool,
        rtl: propTypes.bool,
        topMenu: propTypes.bool,
        changeRtl: propTypes.func,
        changeMenuMode: propTypes.func,
    };



    return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};

export default ThemeLayout;
